import {
  useCreateTravelDocumentPurchase,
  useGetDocumentPurchase,
} from 'api-hooks/order/travel-document';
import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import TravelDocumentOrderForm from './components/form';
import { DocumentPurchaseFormType } from './components/form-type';

export type TravelDocumentOrderViewParams = {
  id: string;
  travelDocumentSale?: TravelDocumentSalesModel;
  defaultValues?: DocumentPurchaseFormType;
};

export default function TravelDocumentOrderView(
  props: NavigationProps<NavigationRoutes.DocumentPurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetDocumentPurchase({
      id,
    });
  const { mutateAsync, error: errorMutate } = useCreateTravelDocumentPurchase();

  const travelDocument = data?.data;

  const onResolve = useApprovalableEdit('document-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <TravelDocumentOrderForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            travelDocument={travelDocument}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
